class BannerHome {
	constructor() {
		this.banner = document.querySelector(".banner-home");


		if (this.banner) {
			this.bg = this.banner.querySelector(".swiper");
			this.textFixed = this.banner.querySelector(".fixe");
			this.textChanging = this.banner.querySelector(".changing");

			this.buildBannerSlider();
			window.addEventListener("mousemove", (e) => {
				this.mouseInteraction(e, this.bg, 0.01);
				this.mouseInteraction(e, this.textFixed, 0.02);
				this.mouseInteraction(e, this.textChanging, 0.03);
			});
		}
	}

	buildBannerSlider() {
		const images = this.banner.querySelector(".swiper");
		const linesContainer = this.banner.querySelector(".banner-home .changing");
		const lines = this.banner.querySelectorAll(".banner-home .changing-line");

		for (let i = 0; i < lines.length; i++) {
			// let firstLine = (i === 0) ? true : false;
			this.textAnim(lines[i]);
		}

		gsap.set(linesContainer, {
			opacity: 1
		});

		this.slider = new Swiper(images, {
			speed: 2000,
			effect: "fade",
			on: {
				init: (slider) => {
					lines[slider.activeIndex].tlChars.play(0);
					// lines[slider.activeIndex].tlLines.play(0);

				},
				slideChangeTransitionStart: (slider) => {
					lines[slider.activeIndex].tlChars.play(0);
					// lines[slider.activeIndex].tlLines.play(0);
				}
			},
		});

		setTimeout(() => {
			this.slider.params.autoplay.delay = 4000;
			this.slider.autoplay.start();
		}, 2000 );
	}

	textAnim(elem) {
		this.splitTitle = new SplitText(elem, {type: "chars, words, lines", charsClass: "char", linesClass: "line"});

		gsap.ticker.lagSmoothing(false);
		elem.tlChars = gsap.timeline();
		// elem.tlLines = gsap.timeline({
		// 	defaults: {
		// 		ease: "linear"
		// 	}
		// });

		elem.tlChars.pause();
		elem.tlChars.fromTo(
			this.splitTitle.chars, {
				autoAlpha: 0,
				//yPercent: -40,
			}, {
				autoAlpha: 1,
				yPercent: 0,
				ease: "Power1.easeOut",
				stagger: {
					each: 0.04,
					from: "random"
				},
				duration: 2.0
			}, 0.6 );
		// elem.tlChars.addPause(3);
		elem.tlChars.to(
			this.splitTitle.chars, {
				autoAlpha: 0,
				//yPercent: 40,
				ease: "Power1.easeIn",
				// stagger: {
				// 	each: 0.03,
				// 	from: "random"
				// },
				duration: 1
			}, 5);

		gsap.set(this.splitTitle.chars, {
			opacity: 0
		});

		// elem.tlLines.pause();
		// elem.tlLines.fromTo(
		// 	this.splitTitle.lines, {
		// 		yPercent: -20,
		// 	}, {
		// 		yPercent: 0,
		// 		duration: 7,
		// 		ease: "linear"
		// 	});

		gsap.set(this.splitTitle.chars, {
			opacity: 0
		});
	}

	mouseInteraction(e, elem, factor = 0.02) {
		const percentX = e.pageX - (window.innerWidth / 2);
		const percentY = e.pageY - (window.innerHeight / 2);

		gsap.to(elem, {
			duration: 0.75,
			x: percentX * factor,
			y: percentY * factor,
			overwrite: true
		});
	}

}